import styled from 'styled-components';

const MenuIcon = styled.div``;

export default MenuIcon;